import { makeStyles } from '@mui/styles';
import { ColorType } from '../../../../assets/colors/colors.g';

const LAYOUT_CONSTANTS = {
  MAX_WIDTH: '425px',
  MODAL_PADDING: '24px',
  WRAPPER_PADDING: '16px',
  BORDER_RADIUS: '8px',
  BORDER_RADIUS_LARGE: '16px',
  BUTTON_HEIGHT: '48px',
} as const;

export const ICON_SIZES = {
  SMALL: { width: '20px', height: '20px' },
  MEDIUM: { width: '24px', height: '24px' },
} as const;

export const usePromoCodeStyles = makeStyles(() => ({
  promoTriggerWrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    margin: '0 auto',
    width: '100%',
    maxWidth: LAYOUT_CONSTANTS.MAX_WIDTH,
    padding: LAYOUT_CONSTANTS.WRAPPER_PADDING,
    zIndex: 10,
    boxSizing: 'border-box',
  },
  promoTriggerFrame: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: ColorType.PROMO_BG,
    borderRadius: LAYOUT_CONSTANTS.BORDER_RADIUS,
    padding: '12px 16px',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
  },
  promoTriggerText: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  promoLabel: {
    color: ColorType.BLACK,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
  },
  chevronIcon: {
    color: ColorType.BLACK,
    width: '24px',
    height: '24px',
  },
  modalOverlay: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  modalContent: {
    backgroundColor: ColorType.WHITE,
    borderRadius: `${LAYOUT_CONSTANTS.BORDER_RADIUS_LARGE} ${LAYOUT_CONSTANTS.BORDER_RADIUS_LARGE} 0 0`,
    width: '100%',
    maxWidth: LAYOUT_CONSTANTS.MAX_WIDTH,
    padding: LAYOUT_CONSTANTS.MODAL_PADDING,
    outline: 'none',
    position: 'relative',
    boxSizing: 'border-box',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  modalTitle: {
    color: ColorType.BLACK,
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
  },
  closeButton: {
    padding: 0,
    color: ColorType.BLACK,
  },
  inputLabel: {
    color: ColorType.BLACK,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    marginBottom: '12px',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      backgroundColor: ColorType.GREY1,
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
      '&.Mui-error fieldset': {
        borderColor: ColorType.NEGATIVE,
        border: '1px solid',
      },
      '&.Mui-error.Mui-focused fieldset': {
        borderColor: ColorType.NEGATIVE,
        border: '1px solid',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontFamily: 'Inter',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: ColorType.BLACK,
      caretColor: ColorType.BLACK,
      '&::placeholder': {
        color: ColorType.GREY4,
        opacity: 1,
      },
      '&.Mui-error': {
        caretColor: ColorType.BLACK,
      },
    },
  },
  errorText: {
    color: ColorType.NEGATIVE,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    marginTop: '8px',
  },
  applyButton: {
    marginTop: '24px',
    width: '100%',
    height: LAYOUT_CONSTANTS.BUTTON_HEIGHT,
    borderRadius: '4px',
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    textTransform: 'none',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    color: ColorType.WHITE,
  },
  successBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    borderRadius: LAYOUT_CONSTANTS.BORDER_RADIUS,
    border: `1px solid ${ColorType.POSITIVE}`,
    backgroundColor: ColorType.WHITE,
    marginTop: '16px',
  },
  successContent: {
    flex: 1,
  },
  successTitle: {
    color: ColorType.BLACK,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
  },
  successDiscount: {
    color: ColorType.GREY5,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '16px',
    marginTop: '2px',
  },
  appliedPromoWrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    margin: '0 auto',
    width: '100%',
    maxWidth: LAYOUT_CONSTANTS.MAX_WIDTH,
    padding: LAYOUT_CONSTANTS.WRAPPER_PADDING,
    zIndex: 10,
    boxSizing: 'border-box',
  },
  appliedPromoFrame: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    backgroundColor: ColorType.POSITIVE0,
    borderRadius: LAYOUT_CONSTANTS.BORDER_RADIUS,
    padding: '12px 16px',
    boxSizing: 'border-box',
  },
  appliedPromoText: {
    color: ColorType.BLACK,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    flex: 1,
  },
}));
